"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _formField = _interopRequireDefault(require("@berlitz/form-field"));
var _checkbox = _interopRequireDefault(require("@berlitz/checkbox"));
var _Form = require("./Form.style");
var _RenderField = _interopRequireDefault(require("./RenderField"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  var _super = _createSuper(Form);
  function Form() {
    var _temp, _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.state = {
      disableNativeFormValidation: false
    }, _this.handleSubmit = function (values, setSubmitting, setStatus, resetForm) {
      _this.props.onSubmit(values, setSubmitting, setStatus, resetForm);
    }, _temp));
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        action = _this$props.action,
        enableReinitialize = _this$props.enableReinitialize,
        fields = _this$props.fields,
        hiddenFields = _this$props.hiddenFields,
        hideSubmitButton = _this$props.hideSubmitButton,
        light = _this$props.light,
        loadingLabel = _this$props.loadingLabel,
        locale = _this$props.locale,
        method = _this$props.method,
        onChange = _this$props.onChange,
        submitButtonRef = _this$props.submitButtonRef,
        submitLabel = _this$props.submitLabel,
        termsLabel = _this$props.termsLabel;
      var disableNativeFormValidation = this.state.disableNativeFormValidation;
      var initialValues = {
        terms: false
      };
      var isRenderCalled = true;
      fields.forEach(function (field) {
        if (field.type === 'checkbox') {
          initialValues[field.name] = field.checked ? field.checkedValue : field.uncheckedValue;
        } else if (field.type === 'checkbox_group') {
          var defaultValues = field.checkboxOptions.filter(function (checkbox) {
            return checkbox.checked;
          }).map(function (checkbox) {
            return checkbox.checkedValue;
          }).join(';');
          initialValues[field.name] = defaultValues;
        } else if (field.type === 'select') {
          if (field.placeholder) {
            initialValues[field.name] = '';
          } else {
            var _field$options, _field$options$;
            initialValues[field.name] = field.value || (field === null || field === void 0 ? void 0 : (_field$options = field.options) === null || _field$options === void 0 ? void 0 : (_field$options$ = _field$options[0]) === null || _field$options$ === void 0 ? void 0 : _field$options$.value) || '';
          }
        } else {
          initialValues[field.name] = field.value;
        }
      });
      hiddenFields.forEach(function (hiddenField) {
        initialValues[hiddenField.name] = hiddenField.value;
      });
      return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
        enableReinitialize: enableReinitialize,
        initialValues: initialValues,
        onSubmit: function onSubmit(values, _ref) {
          var setSubmitting = _ref.setSubmitting,
            setStatus = _ref.setStatus,
            resetForm = _ref.resetForm;
          _this2.handleSubmit(values, setSubmitting, setStatus, resetForm);
        }
      }, function (_ref2) {
        var values = _ref2.values,
          handleChange = _ref2.handleChange,
          handleBlur = _ref2.handleBlur,
          handleSubmit = _ref2.handleSubmit,
          setFieldValue = _ref2.setFieldValue,
          errors = _ref2.errors,
          touched = _ref2.touched,
          isSubmitting = _ref2.isSubmitting;
        if (typeof window !== "undefined") {
          window.formikSetFieldValue = setFieldValue;
        }
        /*  This implementation of onChange is required to ensure the current state is returned.
        Using the built-in onChange of Formik, the previous state is returned */

        if (!isRenderCalled && onChange) {
          onChange(values);
        }
        isRenderCalled = false;
        return /*#__PURE__*/_react.default.createElement(_formik.Form, {
          action: action,
          method: method,
          onSubmit: handleSubmit,
          noValidate: disableNativeFormValidation,
          "data-key": "lead-form__form",
          id: _this2.id
        }, hiddenFields.map(function (field, index) {
          // If a field has a `newValue`, set that value with Formik
          if (typeof field.newValue !== 'undefined' && values[field.name] !== field.newValue) {
            setFieldValue(field.name, field.newValue);
          }
          return /*#__PURE__*/_react.default.createElement("input", {
            name: field.name,
            value: values[field.name],
            onChange: handleChange,
            onBlur: handleBlur,
            type: "hidden",
            key: index
          });
        }), /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
          bottom: "xs"
        }, fields.map(function (field, index) {
          // If a field has a `newValue`, set that value with Formik
          if (typeof field.newValue !== 'undefined' && values[field.name] !== field.newValue) {
            setFieldValue(field.name, field.newValue);
          }
          return /*#__PURE__*/_react.default.createElement(_RenderField.default, {
            errors: errors,
            field: field,
            handleBlur: handleBlur,
            handleChange: handleChange,
            light: light,
            setFieldValue: setFieldValue,
            touched: touched,
            values: values,
            key: index,
            locale: locale
          });
        })), termsLabel && /*#__PURE__*/_react.default.createElement(_formField.default, {
          required: true,
          invalid: errors.terms && touched.terms,
          validationMessage: errors.terms,
          validationMessageLeft: true,
          label: 'Terms and conditions',
          hideLabel: true,
          light: light
        }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
          name: "terms",
          value: "terms",
          checked: values.terms,
          onChange: handleChange,
          label: termsLabel
        })), /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
          center: "xs"
        }, /*#__PURE__*/_react.default.createElement(_Form.SubmitButton, {
          canLoad: true,
          type: "submit",
          ghost: light,
          loading: isSubmitting,
          loadingText: loadingLabel,
          innerRef: submitButtonRef,
          isHidden: hideSubmitButton
        }, submitLabel)));
      });
    }
  }]);
  return Form;
}(_react.default.Component);
Form.defaultProps = {
  submitLabel: 'Submit',
  loadingLabel: 'Loading',
  light: false,
  method: 'post',
  enableReinitialize: true,
  locale: 'en'
};
var _default = Form;
exports.default = _default;